<template>
  <q-dialog
    ref="contactPersonModal"
    @show="onShowHandler"
    @hide="onHideHandler"
  >
    <q-layout
      view="Lhh lpR fff"
      container
      class="bg-white modal-large contactPersonContainer"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="library_add" size="25px" class="q-pr-sm" />
            {{ $gettext(computedTitle) }}
          </q-toolbar-title>
          <q-btn flat @click="hide">
            <q-icon name="cancel" size="2.5em"/>
          </q-btn>
        </q-toolbar>
      </q-header>
      <jt-dynamic-form
        v-if="renderForm"
        ref="compositionForm"
        :inputs="form.inputs"
        :interface="form.nmInterface"
        :relacionamentos="form.relacionamentos"
        :model="form.dadosForm"
        form-class="form"
        class="q-pa-lg formContainer contactPersonForms"
      />
      <section class="contactPersonTabs q-px-lg">
        <q-tabs
          id="phones-tab"
          v-model="tab"
          align="start"
          color="dark"
          dense
          active-color="primary"
          indicator-color="primary"
        >
          <q-tab
            :label="$gettext('PHONE')"
            key="phones"
            name="phones"
            default
          />
        </q-tabs>
        <q-separator />
        <q-tab-panels v-model="tab" animated>
          <q-tab-panel key="phones" name="phones" class="row q-gutter-x-md">
            <span
              v-for="(tel, index) in formModel.contactPersonPhones"
              v-bind:key="index"
              class="col-3 input-phone"
            >
              <jt-tel-input
                :float-label="$gettext('PHONE')"
                :key="index"
                v-model="tel.phone"
                class="tel-input"
                @input="setEditable(tel)"
              />
              <span>
                <q-btn
                  class="bg-blue-grey text-white full-height self-center q-py-xs btn-remove-tell-input "
                  icon="remove"
                  @click="phoneRemove(index)"
                ></q-btn>
              </span>
            </span>
            <q-btn
              class="bg-blue-grey text-white full-height self-center q-py-xs btn-add-tell-input"
              icon="add"
              @click="phoneAdd"
            ></q-btn>

          </q-tab-panel>
        </q-tab-panels>
        <q-tabs
          id="emails-tab"
          v-model="tab2"
          align="start"
          color="dark"
          dense
          active-color="primary"
          indicator-color="primary"
        >
          <q-tab
            :label="$gettext('EMAIL')"
            key="emails"
            name="emails"
            default
          />
        </q-tabs>
        <q-separator />
        <q-tab-panels v-model="tab2" animated>
          <q-tab-panel key="emails" name="emails" class="row q-gutter-x-md">
            <span
              v-for="(em, index) in formModel.contactPersonEmails"
              v-bind:key="index"
              class="col-5 email-input-grid"
            >
              <jt-email-input
                :float-label="$gettext('EMAIL')"
                :key="index"
                v-model="em.email"
                class="jt-email-input"
                @input="setEditable(em)"
              />
              <span>
                <q-btn
                  class="bg-blue-grey text-white full-height self-center q-py-xs btn-remove-email-input"
                  icon="remove"
                  @click="emailRemove(index)"
                ></q-btn>
              </span>
            </span>
            <q-btn
              class="bg-blue-grey text-white full-height self-center q-py-xs btn-add-email-input"
              icon="add"
              @click="emailAdd"
            ></q-btn>
          </q-tab-panel>
        </q-tab-panels>
      </section>
      <section
        class="row justify-center full-width q-gutter-md q-pa-lg sectionContactPerson"
      >
        <div
          v-for="(button, index) in form.buttons"
          :key="index"
          class="col-2 buttonsContactPerson"
        >
          <q-btn
            class="full-width"
            color="positive"
            :name="button.name"
            @click="onFormButtonClickHandler(button)"
            >{{ button.label }}
          </q-btn>
        </div>
      </section>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import {
  JtDynamicForm,
  JtCompositionFormModal,
  JtTelInput,
  JtEmailInput
} from 'jtech-webcomps'
import {
  QDialog,
  QLayout,
  QIcon,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QBtn,
  QTab,
  QTabPanel,
  QTabPanels
} from 'quasar'
import { remove } from 'mobx'
@Component({
  mixins: [JtCompositionFormModal],
  components: {
    JtDynamicForm,
    QDialog,
    QLayout,
    QIcon,
    QToolbar,
    QHeader,
    QToolbarTitle,
    QBtn,
    QTab,
    QTabPanel,
    QTabPanels,
    JtTelInput,
    JtEmailInput
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    composicaos: {
      type: Array,
      required: true
    },
    nrLinhaSelecionada: Number,
    flComposicaoAlteracao: Boolean
  }
})
class ContactPerson extends Vue {
  tab = 'phones';
  tab2 = 'emails';
  renderForm = false;
  formModel = {};
  show () {
    this.renderForm = true
    this.form.inputs = this.form.inputs.filter((i) => i.type != 'COMPOSICAO')
    this.formModel = this.form.dadosForm
    if (!this.formModel.name) {
      this.$set(this.formModel, 'name', '')
    }
    if (!this.formModel.contactPersonPhones) {
      this.$set(this.formModel, 'contactPersonPhones', [])
    }
    if (!this.formModel.contactPersonEmails) {
      this.$set(this.formModel, 'contactPersonEmails', [])
    }
    this.$refs.contactPersonModal.show()
  }

  hide () {
    if (!this.formModel.name) {
      this.$set(this.formModel, 'name', '')
    }
    this.$refs.contactPersonModal.hide()
  }

  phoneAdd () {
    this.formModel.contactPersonPhones.push({ phone: '' })
  }

  phoneRemove (index) {
    this.formModel.contactPersonPhones.splice(index, 1)
  }

  emailAdd () {
    this.formModel.contactPersonEmails.push({ email: '' })
  }

  emailRemove (index) {
    this.formModel.contactPersonEmails.splice(index, 1)
  }

  setEditable (object) {
    if (object.id) object.flAlterado = 'S'
  }

  onFormButtonClickHandler (button) {
    this.removeEmailEmpty()
    this.removePhoneEmpty()

    if (button.name === 'btSalvarComposicao') {
      this.__saveButtonHandler({ button, fields: this.formModel })
    } else if (button.name === 'btFecharComposicao') this.hide()
  }

  removeEmailEmpty () {
    let i = 0
    let length = this.formModel.contactPersonEmails.length

    while (i < length) {
      if (
        this.formModel.contactPersonEmails[i].email === null ||
        this.formModel.contactPersonEmails[i].email === ''
      ) {
        this.formModel.contactPersonEmails.splice(i, 1)
        length--
      } else {
        i++
      }
    }
  }

  removePhoneEmpty () {
    let i = 0
    let length = this.formModel.contactPersonPhones.length

    while (i < length) {
      if (
        this.formModel.contactPersonPhones[i].phone === null ||
        this.formModel.contactPersonPhones[i].phone === ''
      ) {
        this.formModel.contactPersonPhones.splice(i, 1)
        length--
      } else {
        i++
      }
    }
  }
}
export default ContactPerson
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.contactPersonForms .q-scrollarea {
  margin-top: 20px
}

.contactPersonContainer {
  border-radius: 0px !important;
}

.contactPersonContainer .input-phone{
  display: flex;
  gap: 10px
}

.contactPersonContainer .tel-input {
  flex: 1;
}

.contactPersonContainer .btn-remove-tell-input {
  max-height: 44px;
  position: relative;
  top: 5px;
}
.contactPersonContainer .btn-add-tell-input {
  position: relative;
  bottom: 11px;
}
.contactPersonContainer .email-input-grid {
  display: flex;
  gap: 20px;
}
.contactPersonContainer .jt-email-input {
  flex: 1;
}
.contactPersonContainer .btn-remove-email-input {
  max-height: 44px;
  position: relative;
  top: 5px;
}

.contactPersonContainer .btn-add-email-input{
  position: relative;
  bottom: 11px;
}

.contactPersonForms {
  #scroll-area {
    height: calc(22vh - 12px) !important;
  }
}

.sectionContactPerson {
  .buttonsContactPerson:first-child {
    .q-btn {
      background: #A9B9C2 !important;
      color: black;
    }
  }
}

@media only screen and (max-height: 765px) {
  .contactPersonForms {
    #scroll-area {
      height: calc(25vh - 12px) !important;
    }
  }
}
</style>
